var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallRings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 213,
    viewBox: "0 0 86 180",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.304 200.257C127.506 204.018 145.935 197.682 161.003 184.517C176.071 171.352 187.82 151.33 192.727 127.582C197.633 103.833 194.781 80.7944 186.165 62.7364C177.548 44.6777 163.138 31.557 144.936 27.7962C126.734 24.0355 108.304 30.3712 93.2362 43.5363C78.1688 56.701 66.4196 76.7232 61.5129 100.471C56.6063 124.22 59.4585 147.259 68.075 165.317C76.6918 183.375 91.1017 196.496 109.304 200.257Z",
    stroke: "#A7E1FF",
    strokeWidth: 1.66602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2236 198.174C117.425 201.935 135.855 195.599 150.923 182.434C165.991 169.269 177.74 149.247 182.647 125.499C187.553 101.751 184.701 78.7118 176.085 60.6537C167.468 42.595 153.058 29.4743 134.856 25.7136C116.654 21.9529 98.2242 28.2885 83.1562 41.4537C68.0887 54.6183 56.3395 74.6406 51.4328 98.3888C46.5262 122.137 49.3784 145.176 57.9949 163.234C66.6118 181.293 81.0216 194.413 99.2236 198.174Z",
    stroke: "#A7E1FF",
    strokeWidth: 1.66602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.424 195.943C106.626 199.704 125.056 193.368 140.124 180.203C155.191 167.038 166.94 147.016 171.847 123.268C176.754 99.5195 173.901 76.4805 165.285 58.4224C156.668 40.3637 142.258 27.243 124.056 23.4823C105.854 19.7215 87.4246 26.0572 72.3566 39.2223C57.2891 52.387 45.5399 72.4092 40.6333 96.1574C35.7266 119.906 38.5789 142.945 47.1954 161.003C55.8122 179.061 70.2221 192.182 88.424 195.943Z",
    stroke: "#A7E1FF",
    strokeWidth: 1.66602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8222 186.676C92.0241 190.437 110.454 184.101 125.522 170.936C140.589 157.772 152.339 137.749 157.245 114.001C162.152 90.2529 159.3 67.2139 150.683 49.1558C142.066 31.0971 127.656 17.9764 109.455 14.2157C91.2526 10.455 72.8228 16.7906 57.7548 29.9558C42.6873 43.1204 30.9381 63.1427 26.0315 86.8909C21.1248 110.639 23.9771 133.678 32.5936 151.736C41.2104 169.795 55.6203 182.916 73.8222 186.676Z",
    stroke: "#A7E1FF",
    strokeWidth: 1.66602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.861 185.031C84.063 188.792 102.493 182.456 117.561 169.291C132.628 156.127 144.377 136.104 149.284 112.356C154.191 88.608 151.338 65.569 142.722 47.5109C134.105 29.4522 119.695 16.3315 101.493 12.5708C83.2914 8.81007 64.8616 15.1457 49.7936 28.3109C34.7261 41.4755 22.9769 61.4978 18.0703 85.246C13.1637 108.994 16.0159 132.033 24.6324 150.091C33.2492 168.15 47.6591 181.271 65.861 185.031Z",
    stroke: "#A7E1FF",
    strokeWidth: 1.66602
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallRings);
export default __webpack_public_path__ + "static/media/small-rings.341332e05cc2e06d51d8833a9ef35759.svg";
export { ForwardRef as ReactComponent };